export const DIPLOMAS_TRANSLATION_KEY = 'user-panel-diplomas';
export const MAX_VISIBLE_DIPLOMAS = 12;

export const DIPLOMAS_URL_SOURCES = {
  DIPLOMA_CARD: 'Diploma Card',
} as const;
